// eslint-disable-next-line no-unused-vars
import React, { useMemo, SVGAttributes } from 'react'
import Rectangle from './Rectangle'
import Button from './Button'
import Circle from './Circle'
import { getStyleObjWithMargins } from './helpers'

interface PropsInterface extends SVGAttributes<SVGElement>{
    el?: 'p' | 'bar' | 'button' | 'rectangle' | 'div' | 'icon' | 'circle';
    times?: number;
    marginTop?: number;
    marginBottom?: number;
    marginY?: number;
    radius?: number; // for circles
    gap?: number; // if multiple
    height?: number; // px
    fillContent?: boolean; // rectangle based
    pull?: 'right' | 'left'
    'data-testid'?: string;
}

const getProperShapeWithDefaultvalues = (shape, props) => {
    const conf = {
        rectangle: () => Rectangle(props),
        bar: () => Rectangle({ height: 15, fillContent: false, width: '100%', ...props }),
        div: () => Rectangle({ width: '100%', ...props }),
        p: () => Rectangle({ gap: 10, height: 76, width: '100%', fillContent: false, ...props }),
        button: () => Button(props),
        icon: () => Circle({ radius: 18, ...props }),
        circle: () => Circle(props)
    }

    return conf[shape]()
}

/**
 *
 */
const ContentLoaderFactory = ({
    el = 'p',
    times = 1,
    'data-testid': dataTestID,
    ...props
}: PropsInterface): JSX.Element => {
    const marginsStyle = getStyleObjWithMargins(props)
    const dataTestId = dataTestID || `${dataTestID}-${el}`
    let style = { ...marginsStyle }
    if (props.style) {
        style = {
            ...style,
            ...props.style
        }
    }

    return getProperShapeWithDefaultvalues(el, { times, 'data-testid': dataTestId, ...props, style })
}

/**
 *
 */
export type ContentFactoryInterface = PropsInterface

export default ContentLoaderFactory
